// A doctor-initiated discharge drops into all four clearance queues at once.
// Each department clears its own queue; the discharge can only be completed
// once every department has cleared.
export const DISCHARGE_CLEARANCE_DEPARTMENTS = ['nursing', 'pharmacy', 'lab', 'accounts'];

export const DISCHARGE_CLEARANCE_LABELS = {
	nursing: 'Nursing',
	pharmacy: 'Pharmacy',
	lab: 'Laboratory',
	accounts: 'Accounts',
};

// who may clear each queue
const CLEARANCE_ROLES = {
	nursing: ['nurse', 'it-admin', 'medical-director'],
	pharmacy: ['pharmacy', 'pharmacy-supervisor', 'it-admin'],
	lab: ['lab-manager', 'lab-supervisor', 'lab-user', 'it-admin'],
	accounts: ['accounts', 'head-of-accounts', 'it-admin'],
};

export const canClearDischarge = (profile, department) => {
	const slug = profile?.role?.slug;
	if (!slug) return false;
	return (CLEARANCE_ROLES[department] || []).includes(slug);
};

export const isDischargeCleared = admission => (admission?.clearance_status || admission?.clearance_summary?.status) === 'cleared';

// admissions started before this workflow have no clearance rows at all
export const hasClearanceWorkflow = admission => !!(admission?.clearance_summary?.total_count || admission?.clearances?.length);
